
export const removeFromBasket = product => {
  return {
    type: "REMOVE-ITEM-FROM-BASKET",
    product
  }
}

export const clearBasket = () => {
  return {
    type: "CLEAR-BASKET"
  }
}

export const incrementProductQuantity = product => {
  return {
    type: 'INCREMENT-PRODUCT-QUANTITY',
    product
  }
}
export const decrementProductQuantity = product => {
  return {
    type: 'DECREMENT-PRODUCT-QUANTITY',
    product
  }
}

export const addToBasket = product => {
  return {
    type: 'ADD-ITEM-TO-BASKET',
    product
  }
}

export const removeBasketFeature = (productId, featureId) => ({
  type: 'REMOVE-BASKET-FEATURE',
  productId,
  featureId
})

export const updateBasketFeatureQuantity = (productId, featureId, quantity) => ({
  type: 'UPDATE-BASKET-FEATURE-QUANTITY',
  productId,
  featureId,
  quantity
})

export const fetchMainStocks = (data) => {
    return {
      type: 'FETCH-MAIN-STOCKS',
      data: data
    };
}

export const fetchFoodsAction = (data) => ({
  type: 'FETCH-FOODS',
  data
});

export const fetchMarketAction = (data) => ({
  type: 'FETCH-MARKET',
  data
});

export const fetchFeaturedAction = (data) => ({
  type: 'FETCH-FEATURED',
  data
});

export const fetchCategoryAction = (data) => ({
  type: 'FETCH-CATEGORY',
  data
});

export const loadStocksFromFirestore = () => async (dispatch) => {
  const { fetchFoodsData, fetchMarketData, fetchFeaturedData, fetchCategoryData, fetchReviews } = await import('services/backendCalls');
  const { fetchPartners } = await import('DBServices/firestoreDBService');
  
  const [foods, markets, featured, categories, partners, allReviews] = await Promise.all([
    fetchFoodsData(),
    fetchMarketData(),
    fetchFeaturedData(),
    fetchCategoryData(),
    fetchPartners().catch(() => []),
    fetchReviews().catch(() => [])
  ]);

  // Build per-item rating aggregates from approved reviews
  const approvedReviews = Array.isArray(allReviews) ? allReviews.filter(r => r.status === 'approved' || typeof r.status === 'undefined') : [];

  const computeRating = (reviewList) => {
    if (!reviewList.length) return { rating: '0', reviews: 0 };
    const sum = reviewList.reduce((acc, r) => acc + (Number(r.rating) || 0), 0);
    return { rating: (sum / reviewList.length).toFixed(1), reviews: reviewList.length };
  };

  // Match reviews to foods by firestoreId or title/queryBy
  const enrichWithReviews = (items, matchFn) =>
    (items || []).map(item => {
      const matched = approvedReviews.filter(r => matchFn(item, r));
      return matched.length > 0 ? { ...item, ...computeRating(matched) } : item;
    });

  const enrichedFoods = enrichWithReviews(foods, (item, r) =>
    r.productId === item.firestoreId || r.productId === item.queryBy || r.product === item.title
  );

  const enrichedMarkets = enrichWithReviews(markets, (item, r) =>
    r.marketId === item.firestoreId || r.market === item.title
  );

  const approvedFoods = enrichedFoods ? enrichedFoods.filter(f => f.status === 'approved' || typeof f.status === 'undefined') : null;

  let finalMarkets = enrichedMarkets || [];
  if (approvedFoods && partners && partners.length > 0) {
    const partnerMarkets = partners.filter(p => p.partnerType === 'market' && p.verificationStatus === 'approved');
    const partnerMarketsWithFoods = partnerMarkets.filter(p => approvedFoods.some(f => f.partnerMarketId === p.firestoreId));
    
    const mappedPartnerMarkets = partnerMarketsWithFoods.map(p => {
      const pmReviews = approvedReviews.filter(r => r.marketId === p.firestoreId || r.market === p.businessName);
      const pmRating = computeRating(pmReviews);
      return {
        firestoreId: p.firestoreId,
        title: p.businessName,
        queryBy: p.businessName,
        imageSrc: p.businessImage || p.imageSrc || '',
        content: p.description || 'Partner Market',
        rating: pmRating.rating,
        reviews: pmRating.reviews,
        isPartnerMarket: true
      };
    });

    finalMarkets = [...finalMarkets, ...mappedPartnerMarkets];
  }

  if (approvedFoods)      dispatch(fetchFoodsAction(approvedFoods));
  if (finalMarkets.length > 0) dispatch(fetchMarketAction(finalMarkets));
  if (featured)   dispatch(fetchFeaturedAction(featured));
  if (categories) dispatch(fetchCategoryAction(categories));
};

export const fetcSubscriptionRemark = (email) => {
  return {
    type: 'FETCH-SUBSCRIPTION-REMARK',
    email
  };
}


export const setTabAction = (tabName) => {
  return {
    type: 'SET-TAB',
    to: tabName
  };
}





